import { acceptHMRUpdate, defineStore } from "pinia";
import { computed, ref, shallowRef } from "vue";
import  type { Affiliation, EntityWithAffiliations } from "./affiliation";


export const useEntityAffiliationStore = defineStore("EntityAffiliationStore", () => {
  // state
  const affiliations = ref([] as Array<Affiliation>);

  // getters
  const count = computed(() => affiliations.value.length);

  // actions
  function reset() {
    affiliations.value = [];
  }

  function fill(entity: EntityWithAffiliations) {
    const result = entity?.affiliations?._items || [];
    affiliations.value = result;
  }

  function addAffiliation(affiliation: Affiliation) {
    affiliations.value.unshift(affiliation);
  }

  function updateAffiliation(affiliation: Affiliation) {
    const index = affiliations.value.findIndex((x) => x.id === affiliation.id);
    affiliations.value.splice(index, 1, affiliation);
  }

  function deleteAffiliation(affiliation: Affiliation) {
    const index = affiliations.value.findIndex((x) => x.id === affiliation.id);
    affiliations.value.splice(index, 1);
  }

  return {
    //state
    affiliations,
    //getters
    count,
    //actions
    reset,
    fill,
    addAffiliation,
    updateAffiliation,
    deleteAffiliation,
  };
});

export type UseEntityAffiliationStore = ReturnType<typeof useEntityAffiliationStore>;

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useEntityAffiliationStore, import.meta.hot));
}
